import { Spinner } from '@ui';
import { BILLING_OVERVIEW_KEY } from 'components/Cashier/billing';
import { DOMESTIC_COUNTRY, buildInvoiceInformationSchema, InvoiceInformationFields } from 'components/Cashier/InvoiceInformationFields';
import { Form, FormSubmit } from 'components/Form/next';
import Joi from 'joi';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useSWR, { useSWRConfig } from 'swr';
import { useApi } from '../../hooks/useApi';

interface Props {
    callback: () => void;
}

export const withDomesticDefault = (data: any) =>
    data ? { ...data, address: { ...(data.address ?? {}), country: data.address?.country || DOMESTIC_COUNTRY } } : undefined;

export const UpdateInvoiceInformation = ({ callback = () => {} }: Props) => {
    const { t } = useTranslation('mollie');
    const api = useApi();
    const { mutate } = useSWRConfig();
    const { data, error } = useSWR('invoice-information', { revalidateOnFocus: false });
    const [isLoading, setIsLoading] = useState(false);
    const defaultValues = useMemo(() => withDomesticDefault(data), [data]);
    const schema = useMemo(() => Joi.object(buildInvoiceInformationSchema(t)), [t]);

    const handleSubmit = (values) => {
        setIsLoading(true);
        return api({
            url: 'invoice-information',
            method: 'PUT',
            data: values,
            onBefore: () => setIsLoading(false),
            onSuccess: () => {
                void mutate('invoice-information');
                void mutate(BILLING_OVERVIEW_KEY);
                callback();
            }
        });
    };

    if (!data && !error) {
        return (
            <div className="tw-flex tw-justify-center tw-py-6">
                <Spinner />
            </div>
        );
    }

    return (
        <Form onSubmit={handleSubmit} validationSchema={schema} defaultValues={defaultValues}>
            <InvoiceInformationFields />
            <FormSubmit isLoading={isLoading}>{t('billing.invoice.save')}</FormSubmit>
        </Form>
    );
};
